import React from "react";
import { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { v4 as uuidv4 } from "uuid";
import ProductDataSheetLink from "../../common/Shared/ProductDataSheetLink";
import t from "../../../utils/common/translation/translator";
import MsxIcons from "../../common/Icons/MsxIcons/MsxIcons";
import ReactTooltip from "react-tooltip";
import { useSelector } from "react-redux";
import { selectMc12Configuration } from "../../../store/slices/mc12";
import { getCommercializedRefs } from "../../../utils/common/api/api";
import { useEffect } from "react";

const BomSection = ({ title, products }) => {
  const configuration = useSelector(selectMc12Configuration);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [commercializedRefs, setCommercializedRefs] = useState({});

  useEffect(() => {
    const fetchCommercializedRefs = async () => {
      await getCommercializedRefs(
        products.map((product) => product.commercialReference),
        configuration.configData?.locale
      ).then((commercializedRefs) => {
        setCommercializedRefs({ ...commercializedRefs.commercializedProducts });
      });
    };

    fetchCommercializedRefs();
  }, []);
  return (
    <div className="flex flex-col">
      {products?.length > 0 && (
        <>
          <button
            type="button"
            className="bg-gray-400 py-1 px-5 flex items-center gap-4"
            onClick={() => (isCollapsed ? setIsCollapsed(false) : setIsCollapsed(true))}
          >
            {isCollapsed ? <FiChevronDown className="text-white" /> : <FiChevronUp className="text-white" />}
            <span className="text-white font-medium">{title}</span>
          </button>
          {!isCollapsed && (
            <div className="flex flex-col text-xs transition ease-in-out duration-700 ">
              <div className="flex flex-row text-justify bg-gray-5 border-[1px] border-gray-200 text-gray-500">
                <span className="font-normal w-1/3 ml-1">{t("msizer.ui.reference")}</span>
                <span className="font-normal w-2/3">{t("msizer.ui.description")}</span>
                <span className="font-normal w-1/3 text-center">{t("msizer.ui.quantity")}</span>
              </div>
              {products
                .filter((product) => product.quantity > 0)
                .map((product) => {
                  return (
                    <div key={product.commercialReference + uuidv4()} className="flex flex-row">
                      <div className="w-1/3 ">
                        <span className="text-skyBlue underline font-medium pl-2 cursor-pointer">
                          <ProductDataSheetLink reference={product.commercialReference} eventTag="" idLabel="" />
                        </span>
                        <span className="">
                          {Object.keys(commercializedRefs).length > 1 &&
                            !commercializedRefs[product.commercialReference]?.isCommercialized && (
                              <>
                                <MsxIcons
                                  data-tip
                                  data-for={`countryScopeInfo-${product.commercialReference}`}
                                  name="info"
                                  size="nano"
                                  className="text-orange-400 "
                                />
                                <ReactTooltip
                                  id={`countryScopeInfo-${product.commercialReference}`}
                                  type="light"
                                  effect="solid"
                                  backgroundColor="#FFFFFF"
                                  textColor="rgb(31 41 55)"
                                  className="hover:visible shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
                                  multiline
                                >
                                  <div className="space-x-1">
                                    <MsxIcons name="info" size="nano" className="text-orange-400" />
                                    <span className="text-orange-400 font-bold">
                                      {t("msizer.ui.not_commercialized.title")}
                                    </span>
                                  </div>
                                  {t("msizer.ui.not_commercialized")}
                                </ReactTooltip>
                              </>
                            )}
                        </span>
                      </div>
                      <span className="font-normal w-2/3">{product.translatedDescription}</span>
                      <span className="font-normal w-1/3 text-center">{product.quantity}</span>
                    </div>
                  );
                })}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BomSection;
